import { type ExtraValues, type PlatformEvent } from '../types';

export const adIsNotFoundEvent = (extra: ExtraValues): PlatformEvent => {
  return {
    type: 'ad',
    created: Date.now(),
    user_properties: {
      ...(extra && { ...extra.user_properties }),
    },
    event_properties: {
      name: 'not_found',
      ...extra.event_properties,
    },
  };
};
